import { Card, CardContent } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useSession } from '@hooks/useSession';

import type { Profile } from '@models/session';

import AlertRecipientSettingForm from '@views/Alerts/Common/AlertRecipientSettingForm';

import { AccountType, AlertRecipientType } from 'generated/types';

const messages = defineMessages({
  title: {
    id: 'alertRecipientSettingForm.title.organization',
    defaultMessage: 'Organization Alerts',
  },
  subtitle: {
    id: 'alertRecipientSettingForm.subtitle.organization',
    defaultMessage:
      'All alerts may also be sent to your organization’s email and/or mobile number if set up. This is managed in your organization’s settings.',
  },
});

interface AlertSettingsProps {
  user?: Profile;
}

// eslint-disable-next-line no-empty-pattern
function AlertSettings({}: AlertSettingsProps) {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();

  return (
    <Card>
      <CardContent sx={{ my: 1 }}>
        {/* User alert setup */}
        <AlertRecipientSettingForm
          id={activeProfile?.user_id ?? ''}
          type={AlertRecipientType.user}
        />

        {/* Organization alert setup (view only) */}
        {activeProfile?.account?.account_type === AccountType.organization && (
          <AlertRecipientSettingForm
            // Parent ID: for patient child account user
            // Account ID: for org-roled user
            id={activeProfile.account.parent_id ?? activeProfile.account_id}
            overridingText={{
              title: formatMessage(messages.title),
              subtitle: formatMessage(messages.subtitle),
            }}
            type={AlertRecipientType.account}
            viewOnly
          />
        )}
      </CardContent>
    </Card>
  );
}

export default AlertSettings;
